angular.module('app.controllers').controller 'ExpertsListCtrl', [
  '$scope', '$rootScope', 'UI', 'APIRead', 'APIReadTable', 'Table'
].append (self, root, UI, APIRead, APIReadTable, Table) ->

  tableName   = 's.experts.' + (root.user?.shortcode || 'test')
  cookiesName = 't.' + tableName

  self.experts = Table
    name: tableName
    type: "partial"
    resource: APIReadTable
    params:
      limit: 12
      entry_type: 'experts'
  
  self.$watch 'experts.params', (newObj, oldObj) ->
    self.page = 1
  , true

  self.page = 1
  self.loadMore = () ->
    return if self.page >= self.experts.data.pages
    
    self.page++ 
    
    params = angular.copy(self.experts.params)
    params.page = self.page

    self.moreLoad = true
    APIRead.query params, (data) ->
      self.more = data
      self.experts.data.display = self.experts.data.display.concat(self.more)
      self.moreLoad = false
